module.exports = __webpack_public_path__ + "img/icon.b919ade7.png";